import { CURSIVE, SANS_SERIF, SERIF } from '../../constants/embroidery'

export const typeFaceObjs = [SANS_SERIF, CURSIVE, SERIF]

export const positionObjs = [
  { label: '親指部分', value: 'thumbFinger' },
  { label: '小指部分', value: 'childFinger' },
  { label: '小指側背面', value: 'pinkyFingerSideBack' },
  { label: '裏革部分(1段目)', value: 'leatherLiningFirst' },
  { label: '裏革部分(2段目)', value: 'leatherLiningSecond' }
]

export const colorObjs = [
  { label: 'ゴールド', value: 'gold', color: '#D9A948' },
  { label: 'シルバー', value: 'silver', color: '#A7A8A7' },
  { label: 'ライトゴールド', value: 'lightGold', color: '#D7B070' },
  { label: 'ライトシルバー', value: 'lightSilver', color: '#DFDAD4' },
  { label: 'コルク', value: 'cork', color: '#A18555' },
  { label: 'チョコレート', value: 'chocolate', color: '#6F4A35' },
  { label: 'イエロー', value: 'yellow', color: '#F3CD54' },
  { label: 'レモンイエロー', value: 'lemonYellow', color: '#FFF059' },
  { label: 'オレンジ', value: 'orange', color: '#CF7D43' },
  { label: 'レッド', value: 'red', color: '#A03D38' },
  { label: 'パープル', value: 'purple', color: '#8200C6' },
  { label: 'ピンク', value: 'pink', color: '#E57780' },
  { label: 'グリーン', value: 'green', color: '#719B4F' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#0096C9' },
  { label: 'ブルー', value: 'royalBlue', color: '#305173' },
  { label: 'ネイビー', value: 'navy', color: '#2C3F67' },
  { label: 'ブラック', value: 'black', color: '#1A1919' },
  { label: 'ホワイト', value: 'white', color: '#F6F3F0' }
]

export const shadowEdgeColorObjs = [{ label: '不要', value: 'none' }, ...colorObjs]
